import { HttpClient } from '../HttpClient';

/**
 * * Get Spa Migration
 */

export const GetSpaMigrationFlag = async (flagId) => {
  try {
    const { data } = await HttpClient.get(`api/SpaMigrationFlag/${flagId}`);
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
